import { ScientificWorkTypeList } from '@/classes/ScientificWorkTypes'
import { QuoteAgreementStatus } from '@/views/pages/quote-agreement/quote-agreement-data'

const checkMonitoringStatus = [
  {
    color: 'success',
    id: 100,
    uz: 'Muvaffaqiyatli yakunladi',
    ru: 'Успешно завершено',
    en: 'Successfully completed',
  },
  {
    color: 'danger',
    id: 200,
    uz: 'Muvaffaqiyatli yakunlamadi',
    ru: 'Не удалось завершить успешно',
    en: 'Did not complete successfully',
  },
  {
    color: 'warning',
    id: 300,
    uz: 'Muddat  berildi',
    ru: 'Время было дано',
    en: 'Deadline given',
  },
]
export default {
  periodTypes: [],
  // Dc Types

  DSc: 100,
  PhD: 200,
  traineeResearcher: 300,
  independentResearcherDSc: 400,
  independentResearcherPhD: 500,
  targetedDSc: 600,
  targetedPhD: 700,
  doctoralDScOutsideQuota: 800,
  basicDoctoratePhDOutsideQuota: 900,
  traineeResearcherOutsideQuota: 1000,
  doctoralDScUnderContract: 1100,
  basicDoctoratePhDUnderContract: 1200,
  traineeResearcherUnderContract: 1300,
  dcTypes: [
    {
      id: 100,
      name: {
        uz: 'Doktorantura, DSc',
        ru: 'Докторантура, DSc',
        en: 'Doctorate, DSc',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Tayanch doktorantura, PhD',
        ru: 'Базовая докторская степень, PhD',
        en: 'Basic doctorate, PhD',
      },
    },
    {
      id: 300,
      name: {
        uz: 'Stajyor-tadqiqotchi',
        ru: 'Стажер-исследователь',
        en: 'Trainee researcher',
      },
    },
    {
      id: 400,
      name: {
        uz: 'Mustaqil tadqiqotchi, DSc',
        ru: 'Независимый исследователь, DSc',
        en: 'Independent researcher,DSc',
      },
    },
    {
      id: 500,
      name: {
        uz: 'Mustaqil tadqiqotchi, PhD',
        ru: 'Независимый исследователь, PhD',
        en: 'Independent researcher, PhD',
      },
    },
    {
      id: 600,
      name: {
        uz: 'Maqsadli doktorantura, DSc',
        ru: 'Целевая докторская степень, DSc',
        en: 'Target Doctorate, DSc',
      },
    },
    {
      id: 700,
      name: {
        uz: 'Maqsadli tayanch doktorantura, PhD',
        ru: 'Целевая базовая докторская степень, PhD',
        en: 'Targeted Basic Doctorate, PhD',
      },
    },
    {
      id: 800,
      name: {
        uz: 'Doktorantura DSc (kvotadan tashqari)',
        ru: 'Докторантура, DSc (вне квоты)',
        en: 'Doctoral DSc (outside quota)',
      },
    },
    {
      id: 900,
      name: {
        uz: 'Tayanch doktorantura PhD (kvotadan tashqari)',
        ru: 'Базовая докторская степень, PhD (вне квоты)',
        en: 'Basic doctorate, PhD (outside quota)',
      },
    },
    {
      id: 1000,
      name: {
        uz: 'Stajyor-tadqiqotchi (kvotadan tashqari)',
        ru: 'Стажер-исследователь (вне квоты)',
        en: 'Trainee researcher (outside quota)',
      },
    },
    {
      id: 1100,
      name: {
        uz: 'Doktorantura DSc (Shartnoma asosida)',
        ru: 'Докторантура, DSc (на основании договора)',
        en: 'Doctoral DSc (under contract)',
      },
    },
    {
      id: 1200,
      name: {
        uz: 'Tayanch doktorantura PhD (Shartnoma asosida)',
        ru: 'Базовая докторская степень, PhD (на основании договора)',
        en: 'Basic doctorate, PhD (under contract)',
      },
    },
    {
      id: 1300,
      name: {
        uz: 'Stajyor-tadqiqotchi (Shartnoma asosida)',
        ru: 'Стажер-исследователь (на основании договора)',
        en: 'Trainee researcher (under contract)',
      },
    },
  ],

  // roles
  roleApplicant: 100,
  roleDoctorate: 200,
  roleUniversity: 300,
  roleMinistry: 400,
  roleInnovation: 500,
  roleFinance: 600,
  roleResearchAdvisor: 700,
  roleEconomicalMinistry: 800,
  roleAntiCorruption: 900,
  roleOrgHead: 1000,
  roles: [
    {
      id: 100,
      name: {
        uz: 'Ariza beruvchi',
        ru: 'Заявитель',
        en: 'Applicant',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Doktorant',
        ru: 'Докторант',
        en: 'Doctorate',
      },
    },
    {
      id: 300,
      name: {
        uz: 'OTM va ITM',
        ru: 'OTM и ITM',
        en: 'OTM and ITM',
      },
    },
    {
      id: 400,
      name: {
        uz: 'Vazirlik',
        ru: 'Министерство',
        en: 'Ministry',
      },
    },
    {
      id: 500,
      name: {
        uz: 'Innovatsiya',
        ru: 'Инновации',
        en: 'Innovation',
      },
    },
    {
      id: 600,
      name: {
        uz: 'Moliya',
        ru: 'Финансы',
        en: 'Finance',
      },
    },
    {
      id: 700,
      name: {
        uz: 'Ilmiy rahbar',
        ru: 'Научный советник',
        en: 'Research advisor',
      },
    },
    {
      id: 800,
      name: {
        uz: 'Iqtisodiyot vazirligi',
        ru: 'Iqtisodiyot vazirligi',
        en: 'Iqtisodiyot vazirligi',
      },
    },
    {
      id: 900,
      name: {
        uz: 'Antikorrupsiya',
        ru: 'Antikorrupsiya',
        en: 'Antikorrupsiya',
      },
    },
    {
      id: 1000,
      name: {
        uz: "Tashkilot ma'sul rahbari",
        ru: 'Ответственный руководитель организации',
        en: 'Organization responsible head',
      },
    },
  ],

  scientificDegrees: [
    {
      id: 200,
      name: {
        uz: 'Fan doktori',
        ru: 'Доктор наук',
        en: 'Doctor of Science',
      },
    },
    {
      id: 100,
      name: {
        uz: 'Falsafa fanlari doktori',
        ru: 'Доктор Философии',
        en: 'Doctor of Philosophy',
      },
    },
  ],
  scientificTitles: [
    {
      id: 100,
      name: {
        uz: 'Katta ilmiy hodim',
        ru: 'Katta ilmiy hodim',
        en: 'Katta ilmiy hodim',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Dotsent',
        ru: 'Dotsent',
        en: 'Dotsent',
      },
    },
    {
      id: 300,
      name: {
        uz: 'Professor',
        ru: 'Professor',
        en: 'Professor',
      },
    },
    {
      id: 400,
      name: {
        uz: 'Akademik',
        ru: 'Akademik',
        en: 'Akademik',
      },
    },
  ],
  // org types
  orgTypeOTM: 100,
  orgTypeITM: 200,
  orgTypeMinistry: 300,
  orgTypeInnovation: 400,
  orgTypeFinance: 500,
  orgTypes: [
    {
      id: 100,
      name: {
        uz: 'Oliy ta\'lim muassasalari',
        ru: 'Высшие учебные заведения',
        en: 'Higher educational institutions',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Ilmiy tashkilotlar',
        ru: 'Научные организации',
        en: 'Scientific organizations',
      },
    },
    {
      id: 300,
      name: {
        uz: 'Vazirliklar',
        ru: 'Vazirliklar',
        en: 'Vazirliklar',
      },
    },
    {
      id: 400,
      name: {
        uz: 'O\'zR Innovatsion Rivojlanish Vazirliki',
        ru: 'O\'zR Innovatsion Rivojlanish Vazirliki',
        en: 'O\'zR Innovatsion Rivojlanish Vazirliki',
      },
    },
    {
      id: 500,
      name: {
        uz: 'O\'zR Moliya Vazirliki',
        ru: 'O\'zR Moliya Vazirliki',
        en: 'O\'zR Moliya Vazirliki',
      },
    },
  ],
  letterTypeTargeted: 100,
  letterTypeSimple: 200,
  letterStatusDraft: 100,
  letterStatusPending: 200,
  letterStatusRejected: 300,
  letterStatusAccepted: 400,
  letterStatuses: [
    {
      id: 100,
      name: {
        uz: 'Qoralama',
        ru: 'Черновик',
        en: 'Draft',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Kutilmoqda',
        ru: 'В ожидании',
        en: 'Pending',
      },
    },
    {
      id: 300,
      name: {
        uz: 'Rad etilgan',
        ru: 'Отклоненный',
        en: 'Rejected',
      },
    },
    {
      id: 400,
      name: {
        uz: 'Qabul qilingan',
        ru: 'Принятый',
        en: 'Accepted',
      },
    },
  ],
  letterTypes: [
    {
      id: 100,
      name: {
        uz: 'Maksadli',
        ru: 'Целевой',
        en: 'Targeted',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Odatiy',
        ru: 'Обычный',
        en: 'Targeted',
      },
    },
  ],

  // apply document
  applyDocumentStatuses: [
    {
      id: 100,
      name: {
        uz: 'Qoralama',
        ru: 'Черновик',
        en: 'Draft',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Kutilmoqda',
        ru: 'В ожидании',
        en: 'Pending',
      },
    },
    {
      id: 300,
      name: {
        uz: 'Rad etilgan',
        ru: 'Отклоненный',
        en: 'Rejected',
      },
    },
    {
      id: 400,
      name: {
        uz: 'Hujjat qabul qilingan',
        ru: 'Документ был получен',
        en: 'The document has been received',
      },
    },
    {
      id: 500,
      name: {
        uz: "Talabgor o'qishga qabul qilingan",
        ru: 'Абитуриент был принят на учебу',
        en: 'The applicant was admitted to study',
      },
    },
    {
      id: 800,
      name: {
        uz: "Talabgor o'qishga kira olmadi",
        ru: 'Заявитель не мог войти в исследование',
        en: 'The applicant could not enter the study',
      },
    },
    {
      id: 600,
      name: {
        uz: 'Doktorant chetlashtirilgan',
        ru: 'Докторант был отменен',
        en: 'The doctoral student has been canceled',
      },
    },
    {
      id: 700,
      name: {
        uz: "Doktorant o'qishni tugatgan",
        ru: 'Докторант закончил',
        en: 'The doctoral student has graduated',
      },
    },
    {
      id: 900,
      name: {
        uz: 'Muvofaqiyatli himoya qildi',
        ru: 'Успешно защищено',
        en: 'Successfully defended',
      },
    },
    {
      id: 1000,
      name: {
        uz: "Akademik ta'tilda",
        ru: 'On academic leave',
        en: 'В академическом отпускеK',
      },
    },
  ],
  applyDocumentStatusDraft: 100,
  applyDocumentStatusPending: 200,
  applyDocumentStatusRejected: 300,
  applyDocumentStatusAccepted: 400,
  applyDocumentAdmittedToStudy: 500,
  applyDocumentHasBeenCanceled: 600,
  applyDocumentHasGraduated: 700,
  applyDocumentFailedInExam: 800,
  applyDocumentSuccessfullyDefended: 900,
  applyDocumentOnAcademicLeave: 1000,

  // Education Language type
  eduLangTypes: [
    {
      id: 100,
      name: {
        uz: 'O\'zbek tili',
        ru: 'O\'zbek tili',
        en: 'O\'zbek tili',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Rus tili',
        ru: 'Rus tili',
        en: 'Rus tili',
      },
    },
    {
      id: 300,
      name: {
        uz: 'Qoraqolpoq tili',
        ru: 'Qoraqolpoq tili',
        en: 'Qoraqolpoq tili',
      },
    },
  ],

  // scientific work type
  scientificWorkTypes: ScientificWorkTypeList,

  // userTypes
  userTypeForeign: 'F',
  userTypePhysical: 'I',
  userTypeLegalEntity: 'L',
  userTypes: [
    {
      type: 'F',
      name: {
        uz: 'Xorijiy',
        ru: 'Иностранный',
        en: 'Foreign',
      },
    },
    {
      type: 'I',
      name: {
        uz: 'Jismoniy',
        ru: 'Физический',
        en: 'Physical',
      },
    },
    {
      type: 'L',
      name: {
        uz: 'Yuridik shahs',
        ru: 'Юридическое лицо',
        en: 'Legal entity',
      },
    },
  ],
  activeQuarter: {},

  // steps
  stepFinancialQuoteDistribution: 5,
  stepInnovationQuoteDistribution: 6,
  stepsCountInPeriod: 7,

  // Quote org type
  quoteOrgTypes: [
    {
      id: 100,
      name: {
        uz: 'Talim sohasi bo\'yicha (OTM)',
        ru: 'По направлению Образование',
        en: 'In the field of Education',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Fan sohasi bo‘yicha (ITM)',
        ru: 'По направлению Наука',
        en: 'In the field of Science',
      },
    },
    {
      id: 300,
      name: {
        uz: 'Barcha yo\'nalish bo\'yicha',
        ru: 'Во всех направлениях',
        en: 'In all directions',
      },
    },
  ],
  quoteOrgTypeOTM: 100,
  quoteOrgTypeITM: 200,
  quoteOrgTypeCommon: 300,

  // total quote type
  totalQuoteTypes: [
    {
      id: 100,
      name: {
        uz: 'Berish',
        ru: 'Распределение',
        en: 'Give',
      },
    },
    {
      id: 200,
      name: {
        uz: 'So\'rash',
        ru: 'Запрос',
        en: 'Request',
      },
    },
  ],
  totalQuoteTypeGive: 100,
  totalQuoteTypeRequest: 200,

  // quote distribution status
  quoteDistributionDraft: 100,
  quoteDistributionPending: 200,
  quoteDistributionRejected: 300,
  quoteDistributionAccepted: 400,
  quoteDistributions: [
    {
      id: 100,
      name: {
        uz: 'Qoralama',
        ru: 'Черновик',
        en: 'Draft',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Kutilmoqda',
        ru: 'В ожидании',
        en: 'Pending',
      },
    },
    {
      id: 300,
      name: {
        uz: 'Rad etilgan',
        ru: 'Отклоненный',
        en: 'Rejected',
      },
    },
    {
      id: 400,
      name: {
        uz: 'Qabul qilingan',
        ru: 'Принято',
        en: 'Accepted',
      },
    },
  ],
  // exam result statuses
  examResultStatuses: [
    {
      id: 100,
      name: {
        uz: 'Talabgor o\'qishga kira olmadi',
        ru: 'Заявитель не мог войти в исследование',
        en: 'The applicant could not enter the study',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Talabgor o\'qishga qabul qilindi',
        ru: 'Абитуриент был принят на учебу',
        en: 'The applicant was admitted to study',
      },
    },
    {
      id: 300,
      name: {
        uz: 'Talabgor o\'qishga qo\'shimcha asosida kirdi',
        ru: 'Абитуриент поступил на учебу на дополнительной основе',
        en: 'The applicant entered the study on an additional basis',
      },
    },
  ],
  // exam result statuses
  examResultStatusesFirst: [
    {
      id: 100,
      name: {
        uz: 'Talabgor o\'qishga kira olmadi',
        ru: 'Заявитель не мог войти в исследование',
        en: 'The applicant could not enter the study',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Talabgor o\'qishga qabul qilindi',
        ru: 'Абитуриент был принят на учебу',
        en: 'The applicant was admitted to study',
      },
    },
    // {
    //   id: 300,
    //   name: {
    //     uz: "Talabgor o'qishga qo'shimcha asosida kirdi",
    //     ru: 'Абитуриент поступил на учебу на дополнительной основе',
    //     en: 'The applicant entered the study on an additional basis',
    //   },
    // },
  ],
  examResultNotAccepted: 100,
  examResultAccepted: 200,
  examResultAdditionalAccepted: 300,

  // Exam file types
  examFileTypes: [
    {
      id: 100,
      name: {
        uz: 'Protokol',
        ru: 'Протокол',
        en: 'Protocol',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Buyruq',
        ru: 'Приказ',
        en: 'Order',
      },
    },
  ],
  examStatusDraft: 100,
  examStatusFinish: 200,
  examStatusAfterFinish: 300,
  examStatuses: [
    {
      id: 100,
      name: {
        uz: 'Qoralama',
        ru: 'Черновик',
        en: 'Draft',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Finished',
        ru: 'Finished',
        en: 'Finished',
      },
    },
    {
      id: 300,
      name: {
        uz: 'After finished',
        ru: 'After finished',
        en: 'After finished',
      },
    },
  ],

  // post status
  postStatusDraft: 100,
  postStatusNotActive: 200,
  postStatusActive: 300,
  postStatuses: [
    {
      id: 100,
      name: {
        uz: 'Qoralama',
        ru: 'Черновик',
        en: 'Draft',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Faol emas',
        ru: 'Не активный',
        en: 'Not active',
      },
    },
    {
      id: 300,
      name: {
        uz: 'Faol',
        ru: 'Активный',
        en: 'Active',
      },
    },
  ],
  quotes: [],
  directionList: [],
  universityList: [],
  periodList: [],
  admissionYearPeriodList: [],
  categorySubjectList: [],

  additionalExamSubjects: [
    {
      id: 100,
      uz: 'Mutaxasislik fani',
      ru: 'Предмет специальности',
      en: 'Specialty subject',
    },
    {
      id: 200,
      uz: 'Xorijiy til',
      ru: 'Иностранный язык',
      en: 'Foreign language',
    },
    {
      id: 300,
      uz: 'Qo\'shimcha fan 1',
      ru: 'Дополнительный предмет 1',
      en: 'Additional subject 1',
    },
    {
      id: 400,
      uz: 'Qo\'shimcha fan 2',
      ru: 'Дополнительный предмет 2',
      en: 'Additional subject 2',
    },
    {
      id: 500,
      uz: 'Qo\'shimcha fan 3',
      ru: 'Дополнительный предмет 3',
      en: 'Additional subject 3',
    },
  ],
  additionalExamCheckStatus: [
    {
      id: 100,
      uz: 'O\'tdi',
      ru: 'Сдал',
      en: 'Passed',
    },
    {
      id: 200,
      uz: 'O\'tmadi',
      ru: 'Не сдал',
      en: 'Failed',
    },
    {
      id: 300,
      uz: 'Shartli ravishda o\'tdi',
      ru: 'Условно сдал',
      en: 'Conditionally passed',
    },
  ],
  checkMonitoringStatus,
  checkMonitoringAllStatus: [
    {
      color: 'gray',
      id: 50,
      uz: 'Hujjatlar yuklanmagan',
      ru: 'Не завершено',
      en: 'Not completed',
    },
    ...checkMonitoringStatus,
  ],
  checkMonitoringStatusWithName: [
    {
      color: 'success',
      id: 100,
      name: {
        uz: 'Yakka tartibdagi rejasini bajarmagan',
        ru: 'Не выполнил индивидуальный план',
        en: 'Did not fulfill the individual plan',
      },
    },
    {
      color: 'danger',
      id: 200,
      name: {
        uz: 'Izlanuvchi vafot etgan',
        ru: 'Соискатель скончался',
        en: 'The applicant has passed away',
      },
    },
    {
      color: 'warning',
      id: 300,
      name: {
        uz: 'Tashkilot ichki tartibi va qoidalarini buzgan',
        ru: 'Нарушил внутренние правила и порядок организации',
        en: "Violated the organization's internal rules and regulations",
      },
    },
  ],
  checkMonitoringReasonStatus: [
    {
      color: 'danger',
      id: 100,
      uz: 'Yakka tartibdagi rejasini bajarmagan',
      ru: 'Не выполнил индивидуальный план',
      en: 'Did not fulfill the individual plan',
    },
    {
      color: 'danger',
      id: 300,
      uz: 'Tashkilot ichki tartibi va qoidalarini buzgan',
      ru: 'Нарушил внутренние правила и порядок организации',
      en: "Violated the organization's internal rules and regulations",
    },
    {
      color: 'danger',
      id: 200,
      uz: 'Izlanuvchi vafot etgan',
      ru: 'Соискатель скончался',
      en: 'The applicant has passed away',
    },
  ],
  genders: [
    {
      id: 1,
      name: {
        uz: 'Erkak',
        ru: 'Мужской',
        en: 'Male',
      },
    },
    {
      id: 2,
      name: {
        uz: 'Ayol',
        ru: 'Женский пол',
        en: 'Female',
      },
    },
  ],
  ages: [
    {
      id: 100,
      name: {
        uz: '40 yoshgacha',
        ru: 'До 40 лет',
        en: 'Up to 40 years old',
      },
    },
    {
      id: 200,
      name: {
        uz: '40 yoshdan yuqorila',
        ru: 'После 40 лет',
        en: 'After 40 years',
      },
    },
  ],
  organizationList: [],
  organizationStatusActive: 100,
  organizationStatusNotActive: 200,
  organizationStatuses: [
    {
      id: 100,
      name: {
        uz: 'Faol',
        ru: 'Активный',
        en: 'Active',
      },
    },
    {
      id: 200,
      name: {
        uz: 'Faol emas',
        ru: 'Не активный',
        en: 'Not active',
      },
    },
  ],
  scholarshipStatuses: [
    {
      id: '100',
      name: {
        uz: 'Byudjet hisobidan',
        ru: 'Из бюджета',
        en: 'From the budget',
      },
    },
    {
      id: '200',
      name: {
        uz: 'Stipendiyasiz',
        ru: 'Без стипендии',
        en: 'Without scholarship',
      },
    },
    {
      id: '300',
      name: {
        uz: 'Xorijiy (o‘z hisobidan)',
        ru: 'Иностранный (за свой счет)',
        en: 'Foreign (own expense)',
      },
    },
    {
      id: '400',
      name: {
        uz: 'Tashkilot hisobidan',
        ru: 'За счет организации',
        en: 'From the organization',
      },
    },
  ],
  researchAdvisors: [],
  regions: [],
  quoteAgreementStatus: [
    {
      id: QuoteAgreementStatus.DRAFT,
      name: {
        uz: 'Kutilmoqda',
        ru: 'В ожидании',
        en: 'Pending',
      },
      color: 'warning',
    },
    {
      id: QuoteAgreementStatus.ACCEPTED,
      name: {
        uz: 'Qabul qilingan',
        ru: 'Принятый',
        en: 'Accepted',
      },
      color: 'success',
    },
    {
      id: QuoteAgreementStatus.REJECTED,
      name: {
        uz: 'Rad etilgan',
        ru: 'Отклоненный',
        en: 'Rejected',
      },
      color: 'danger',
    },
  ],
  scientificTopicDirections: [],
  certificateList: [],
  certificateTypes: [],
}
